import type { SxProps, Theme } from '@mui/material';

export function mergeSx(...args: (SxProps<Theme> | undefined)[]) {
    return args
        .filter(Boolean)
        .map((sx) => (Array.isArray(sx) ? sx : [sx]))
        .flat() as SxProps<Theme>;
}
